export default {"src":"/_next/static/media/basketball.8e485ced.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};